import { Reveal } from "@/components/Reveal";
import { EcgLine } from "@/components/EcgLine";

const services = [
  {
    id: "echo",
    code: "S.01",
    title: "Echocardiogram",
    detail: "Comprehensive heart ultrasound assessment and reporting using high-quality cardiac ultrasound equipment.",
  },
  {
    id: "ecg",
    code: "S.02",
    title: "12-Lead ECG",
    detail: "Resting electrocardiography performed as part of a cardiovascular diagnostic pathway or research protocol.",
  },
  {
    id: "holter",
    code: "S.03",
    title: "Holter Monitoring",
    detail: "Continuous ambulatory ECG monitoring from 24 hours up to 28 days — for arrhythmias, palpitations and rhythm-related symptoms.",
  },
  {
    id: "abpm",
    code: "S.04",
    title: "24-Hour Ambulatory BP",
    detail: "Beat-to-beat 24-hour blood pressure monitoring to support the diagnosis and management of hypertension.",
  },
];

export const Services = () => (
  <section id="services" className="bg-navy py-28 lg:py-36 relative overflow-hidden" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 relative z-10">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-20">
        <Reveal>
          <p className="font-mono text-[11px] tracking-[0.35em] uppercase text-gold mb-4">
            Non-Invasive Investigations
          </p>
          <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold text-ivory max-w-xl leading-tight">
            A complete cardiac diagnostic repertoire, configured to your pathway.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <EcgLine className="text-gold/60 h-10 w-64 hidden lg:block" />
        </Reveal>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-ivory/10 border border-ivory/10">
        {services.map((s, i) => (
          <Reveal key={s.id} delay={i * 0.08} className="bg-navy">
            <div
              className="p-10 h-full group border border-transparent hover:border-gold/50 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(197,160,89,0.12)] transition-[transform,border-color,box-shadow] duration-500"
              data-testid={`service-card-${s.id}`}
            >
              <p className="font-mono text-xs tracking-[0.3em] text-gold/70 mb-8">{s.code}</p>
              <h3 className="font-serif text-2xl font-semibold text-ivory mb-4 group-hover:text-champagne transition-colors duration-300">
                {s.title}
              </h3>
              <p className="text-sm leading-relaxed text-ivory/50">{s.detail}</p>
            </div>
          </Reveal>
        ))}
        <Reveal delay={0.35} className="bg-navy">
          <div className="p-10 h-full flex flex-col justify-between bg-gold md:col-span-2 lg:col-span-1">
            <p className="font-mono text-xs tracking-[0.3em] text-navy/70">S.05</p>
            <div>
              <h3 className="font-serif text-2xl font-semibold text-navy mb-3">
                Configured Services
              </h3>
              <p className="text-sm leading-relaxed text-navy/70">
                Every service is shaped around the requirements of your healthcare
                organisation, clinical pathway or research protocol.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
